import React from 'react'
import DynamicLink from '../atoms/DynamicLink'

const FooterContactForm = ({ link, isMobile, onClick = null }) => (
  <div className={isMobile ? 'xl:hidden mb-11' : 'hidden xl:block'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      className="mb-1.5"
    >
      <path
        fill="#000"
        d="M0 4v10a2 2 0 002 2h6v5l5-5h7a2 2 0 002-2V4a2 2 0 00-2-2H2a2 2 0 00-2 2z"
      ></path>
      <circle cx="6" cy="9" r="1" fill="#fff"></circle>
      <circle cx="11" cy="9" r="1" fill="#fff"></circle>
      <circle cx="16" cy="9" r="1" fill="#fff"></circle>
    </svg>

    <DynamicLink
      link={link}
      className="underline text-[15px] font-bold leading-normal mb-3 transition-colors hover:text-red-as"
      onClick={onClick}
    />
  </div>
)

export default FooterContactForm
